/* KOYA — customer reviews (framework-free) */
(function () {
  'use strict';

  var root = document.querySelector('[data-creviews]');
  if (!root) return;

  var API = (root.dataset.api || '').replace(/\/+$/, '');
  var PRODUCT_ID = root.dataset.productId || '';
  var PRODUCT_HANDLE = root.dataset.productHandle || '';
  var MAX_PHOTOS = 4;
  var PAGE = 20;
  if (!API || !PRODUCT_ID) return;

  var $ = function (sel) { return root.querySelector(sel); };
  var offset = 0;
  var rating = 0;
  var slots = [];

  /* ── Load and render ──────────────────────────────────────────────────── */

  /* Exactly one of these three rows is on screen at a time. */
  function showRow(which) {
    ['top', 'empty', 'failed'].forEach(function (key) {
      var el = $('[data-cr-' + key + ']');
      if (el) el.hidden = key !== which;
    });
  }

  function load(append) {
    var url = API + '/api/reviews?product_id=' + encodeURIComponent(PRODUCT_ID) +
              '&limit=' + PAGE + '&offset=' + offset;
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.error) throw new Error(data.error);
        var total = (data.summary && data.summary.total) || 0;
        showRow(total ? 'top' : 'empty');
        if (!append) startTeaser(data.reviews || []);
        renderSummary(data.summary);
        renderList(data.reviews, append);
        var more = $('[data-cr-more]');
        if (more) more.hidden = !data.has_more;
        offset += (data.reviews || []).length;
      })
      .catch(function () {
        if (!append) showRow('failed');
      });
  }

  function renderSummary(s) {
    if (!s || !s.total) return;
    $('[data-cr-avg]').textContent = Number(s.average).toFixed(1);
    $('[data-cr-total]').textContent = s.total;
    $('[data-cr-stars]').innerHTML = starsHTML(s.average);

    $('[data-cr-bars]').innerHTML = [5, 4, 3, 2, 1].map(function (n) {
      var c = s.distribution[n] || 0;
      var pct = s.total ? Math.round((c / s.total) * 100) : 0;
      return '<div class="creviews-bar">' +
             '<span class="creviews-bar-n">' + n + '★</span>' +
             '<span class="creviews-bar-track"><span style="width:' + pct + '%"></span></span>' +
             '<span class="creviews-bar-c">' + c + '</span></div>';
    }).join('');
  }

  /* ── Teaser ───────────────────────────────────────────────────────────── */

  var teaserTimer = null;

  /**
   * Cycles one real review through the empty middle of the bar. The text is
   * set in full and clipped by CSS, so it always fits whatever width is left
   * rather than being cut to a guessed number of characters.
   */
  function startTeaser(reviews) {
    var el = $('[data-cr-teaser]');
    if (!el) return;
    if (teaserTimer) { clearInterval(teaserTimer); teaserTimer = null; }

    var lines = reviews
      .filter(function (r) { return r.body && r.body.trim().length > 20; })
      .map(function (r) {
        return '“' + r.body.trim().replace(/\s+/g, ' ') + '” — ' + r.name;
      });

    if (!lines.length) { el.textContent = ''; return; }

    var i = 0;
    el.textContent = lines[0];
    if (lines.length < 2) return;

    // Anyone who has asked for less motion gets one quote, held still.
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (still) return;

    function advance() {
      el.classList.add('is-fading');
      setTimeout(function () {
        i = (i + 1) % lines.length;
        el.textContent = lines[i];
        el.classList.remove('is-fading');
      }, 260);
    }

    teaserTimer = setInterval(advance, 3000);

    // Stop moving while it is being read, or while the section is open.
    var bar = $('[data-cr-top]');
    if (bar) {
      bar.addEventListener('mouseenter', function () { clearInterval(teaserTimer); teaserTimer = null; });
      bar.addEventListener('mouseleave', function () {
        if (!teaserTimer && !isExpanded()) teaserTimer = setInterval(advance, 3000);
      });
    }
  }

  /* ── Expand / collapse ────────────────────────────────────────────────── */

  function setExpanded(open) {
    var details = $('[data-cr-details]');
    var toggle = $('[data-cr-toggle]');
    if (!details || !toggle) return;
    details.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && teaserTimer) { clearInterval(teaserTimer); teaserTimer = null; }
  }
  function isExpanded() {
    var toggle = $('[data-cr-toggle]');
    return !!toggle && toggle.getAttribute('aria-expanded') === 'true';
  }

  function renderList(reviews, append) {
    var list = $('[data-cr-list]');
    if (!list) return;
    if (!append) list.innerHTML = '';

    if (!reviews || !reviews.length) {
      if (!append) list.innerHTML = '<p class="creviews-loading">No reviews yet — be the first.</p>';
      return;
    }

    reviews.forEach(function (r) {
      var el = document.createElement('article');
      // A before/after picture IS the review — it gets room, not a thumbnail.
      el.className = 'creviews-item' + (r.before_after ? ' creviews-item--ba' : '');

      var photos = (r.photos || []).map(function (p) {
        // Seeded reviews can point at an image already hosted on the storefront.
        var src = esc(/^https?:\/\//.test(p) ? p : API + p);
        return '<a href="' + src + '" target="_blank" rel="noopener">' +
               '<img src="' + src + '" alt="" loading="lazy"></a>';
      }).join('');

      el.innerHTML =
        '<header class="creviews-item-head">' +
          '<span class="stars">' + starsHTML(r.rating) + '</span>' +
          (r.verified ? '<span class="creviews-pill">Verified buyer</span>' : '') +
          (r.before_after ? '<span class="creviews-pill creviews-pill--ba">Before &amp; after</span>' : '') +
        '</header>' +
        (r.title ? '<h4 class="creviews-item-title">' + esc(r.title) + '</h4>' : '') +
        '<p class="creviews-item-body">' + esc(r.body) + '</p>' +
        (photos ? '<div class="creviews-item-photos">' + photos + '</div>' : '') +
        '<p class="creviews-item-meta">' + esc(r.name) + ' · ' + fmtDate(r.created_at) + '</p>';

      list.appendChild(el);
    });
  }

  function starsHTML(value) {
    var pct = Math.max(0, Math.min(100, (Number(value) / 5) * 100));
    var one = '<svg aria-hidden="true"><use href="#star"></use></svg>';
    return '<span class="stars stars--frac" style="--star-fill:' + pct + '%">' +
      '<span class="stars__row stars__row--empty">' + one.repeat(5) + '</span>' +
      '<span class="stars__row stars__row--fill">' + one.repeat(5) + '</span></span>';
  }

  /* ── Modal ────────────────────────────────────────────────────────────── */

  function openModal() {
    var m = $('[data-cr-modal]');
    if (!m) return;
    m.hidden = false;
    document.body.style.overflow = 'hidden';
    var first = m.querySelector('input[name="name"]');
    if (first) setTimeout(function () { first.focus(); }, 60);
  }
  function closeModal() {
    var m = $('[data-cr-modal]');
    if (!m) return;
    m.hidden = true;
    document.body.style.overflow = '';
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cr-open]')) { e.preventDefault(); openModal(); }
    if (e.target.closest('[data-cr-close]')) { e.preventDefault(); closeModal(); }
    if (e.target.closest('[data-cr-more]')) { e.preventDefault(); load(true); }
    if (e.target.closest('[data-cr-toggle]')) { e.preventDefault(); setExpanded(!isExpanded()); }

    var star = e.target.closest('.creviews-star');
    if (star) {
      e.preventDefault();
      setRating(parseInt(star.dataset.value, 10));
    }
    if (e.target.closest('[data-cr-add]')) { e.preventDefault(); addSlot(); }

    var rm = e.target.closest('[data-cr-remove]');
    if (rm) { e.preventDefault(); removeSlot(parseInt(rm.dataset.index, 10)); }

    if (e.target.closest('[data-cr-copy]')) {
      e.preventDefault();
      var code = $('[data-cr-code]');
      if (code && navigator.clipboard) {
        navigator.clipboard.writeText(code.textContent.trim());
        e.target.closest('[data-cr-copy]').textContent = 'Copied';
      }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  function setRating(n) {
    rating = n;
    root.querySelectorAll('.creviews-star').forEach(function (b) {
      var on = parseInt(b.dataset.value, 10) <= n;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on && parseInt(b.dataset.value, 10) === n ? 'true' : 'false');
    });
  }

  /* ── Photo slots ──────────────────────────────────────────────────────── */

  function addSlot() {
    if (slots.length >= MAX_PHOTOS) return;
    slots.push({ file: null, tag: slots.length === 0 ? 'before' : slots.length === 1 ? 'after' : 'other' });
    renderSlots();
  }
  function removeSlot(i) { slots.splice(i, 1); renderSlots(); }

  function renderSlots() {
    var wrap = $('[data-cr-slots]');
    if (!wrap) return;
    wrap.innerHTML = slots.map(function (s, i) {
      return '<div class="creviews-slot">' +
        '<div class="creviews-slot-pic" data-cr-pic="' + i + '">' +
          (s.preview ? '<img src="' + s.preview + '" alt="">' : '<span>Choose photo</span>') +
        '</div>' +
        '<input type="file" accept="image/jpeg,image/png,image/webp" hidden data-cr-file="' + i + '">' +
        '<select class="field creviews-tag" data-cr-tag="' + i + '">' +
          '<option value="before"' + (s.tag === 'before' ? ' selected' : '') + '>Before</option>' +
          '<option value="after"'  + (s.tag === 'after'  ? ' selected' : '') + '>After</option>' +
          '<option value="other"'  + (s.tag === 'other'  ? ' selected' : '') + '>Other</option>' +
        '</select>' +
        '<button type="button" class="creviews-slot-x" data-cr-remove data-index="' + i + '" aria-label="Remove photo">&times;</button>' +
      '</div>';
    }).join('');

    var addBtn = $('[data-cr-add]');
    if (addBtn) addBtn.hidden = slots.length >= MAX_PHOTOS;

    wrap.querySelectorAll('[data-cr-pic]').forEach(function (el) {
      el.addEventListener('click', function () {
        wrap.querySelector('[data-cr-file="' + el.dataset.crPic + '"]').click();
      });
    });
    wrap.querySelectorAll('[data-cr-file]').forEach(function (input) {
      input.addEventListener('change', function () {
        var i = parseInt(input.dataset.crFile, 10);
        var f = input.files && input.files[0];
        if (!f) return;
        // Re-encoding through a canvas shrinks the file AND drops EXIF —
        // which matters, because phone photos carry GPS coordinates.
        downscale(f).then(function (out) {
          slots[i].file = out.blob;
          slots[i].preview = out.url;
          renderSlots();
        });
      });
    });
    wrap.querySelectorAll('[data-cr-tag]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        slots[parseInt(sel.dataset.crTag, 10)].tag = sel.value;
      });
    });
  }

  function downscale(file) {
    return new Promise(function (resolve) {
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function () {
        var max = 1600;
        var scale = Math.min(1, max / Math.max(img.width, img.height));
        var c = document.createElement('canvas');
        c.width = Math.round(img.width * scale);
        c.height = Math.round(img.height * scale);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        c.toBlob(function (blob) {
          URL.revokeObjectURL(url);
          resolve({ blob: blob || file, url: c.toDataURL('image/jpeg', 0.7) });
        }, 'image/jpeg', 0.85);
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve({ blob: file, url: '' }); };
      img.src = url;
    });
  }

  /* ── Submit ───────────────────────────────────────────────────────────── */

  var form = $('[data-cr-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = $('[data-cr-error]');
      var btn = $('[data-cr-submit]');

      function fail(msg) {
        err.textContent = msg;
        err.hidden = false;
        err.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
      err.hidden = true;

      if (!rating) return fail('Please choose a star rating.');
      var fd = new FormData(form);
      if (!String(fd.get('name') || '').trim()) return fail('Please enter your name.');
      // Phone is the identifier here, not email. Email is genuinely optional,
      // but if one is typed it should at least look like an address.
      var phoneDigits = String(fd.get('phone') || '').replace(/\D/g, '');
      if (phoneDigits.length < 6) return fail('Please enter the phone number from your order.');
      var emailTyped = String(fd.get('email') || '').trim();
      if (emailTyped && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(emailTyped)) {
        return fail('That email address does not look right.');
      }
      if (String(fd.get('body') || '').trim().length < 10) return fail('Please write a little more about your experience.');

      var payload = new FormData();
      payload.append('product_id', PRODUCT_ID);
      payload.append('product_handle', PRODUCT_HANDLE);
      payload.append('rating', String(rating));
      payload.append('name', fd.get('name'));
      payload.append('phone', fd.get('phone'));
      payload.append('email', fd.get('email') || '');
      payload.append('title', fd.get('title') || '');
      payload.append('body', fd.get('body'));
      payload.append('website', fd.get('website') || '');

      slots.forEach(function (s, i) {
        if (s.file) {
          payload.append('photo_' + i, s.file, 'photo' + i + '.jpg');
          payload.append('tag_' + i, s.tag);
        }
      });

      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = 'Sending…';

      fetch(API + '/api/reviews', { method: 'POST', body: payload })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.error) throw new Error(res.j.error || 'Something went wrong.');
          showDone(res.j);
        })
        .catch(function (e2) { fail(e2.message || 'Something went wrong. Please try again.'); })
        .finally(function () { btn.disabled = false; btn.textContent = original; });
    });
  }

  function showDone(data) {
    form.hidden = true;
    var done = $('[data-cr-done]');
    done.hidden = false;
    $('[data-cr-done-msg]').textContent = data.message || 'Thank you.';

    var offerBox = $('[data-cr-done-offer]');
    if (offerBox) {
      offerBox.hidden = !data.offer;
      if (data.offer) $('[data-cr-done-offer-text]').textContent = data.offer;
    }
    if (data.discount_code) {
      $('[data-cr-code-wrap]').hidden = false;
      $('[data-cr-code]').textContent = data.discount_code;
    }
    // A review that went live should be visible without hunting for it.
    if (data.status === 'approved') {
      offset = 0;
      load(false).then(function () { setExpanded(true); });
    }
  }

  /* ── Utils ────────────────────────────────────────────────────────────── */

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function fmtDate(sec) {
    try {
      return new Date(sec * 1000).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    } catch { return ''; }
  }

  addSlot();
  load(false);
})();
